export default __webpack_public_path__ + "static/media/2020.70c48bd9.mp3";